(() => {
  'use strict';

  const FORM_ID = '1125652';
  const STYLE_ID = `zv-review-native-shadow-${FORM_ID}`;
  const ROOT_SELECTOR = [
    `.zv-review-native-form [data-form-root][data-forms-id="forms-root-${FORM_ID}"]`,
    `.zv-review-native-form [data-forms-id="forms-root-${FORM_ID}"]`
  ].join(',');
  const EMBED_SELECTOR = 'shopify-forms-embed, form-embed';
  const DEFAULT_RATING_LABEL = window.ZinVoltI18n.t("how_satisfied_are_you_with_your_zinvolt_b8cd67");
  const DEFAULT_TEXTAREA_PLACEHOLDER = window.ZinVoltI18n.t("tell_us_about_your_experience_a05dea");
  const DISCLAIMER_PREFIX = 'door dit formulier te versturen';
  const shadowObservers = new WeakMap();

  const SHADOW_CSS = `
    :host {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow: visible !important;
      --inline-container-max-width: 100% !important;
      --form-field-border-radius: 14px !important;
      --button-border-radius: 999px !important;
      --forms-body-font: normal 300 15px Poppins, Arial, sans-serif !important;
      --forms-heading-font: normal 700 28px Poppins, Arial, sans-serif !important;
    }

    #app-embed,
    [data-testid="app-router"],
    #form-container-ref,
    #form-container-ref > section,
    section[data-sizing="form-wrapper"],
    section[role="dialog"][data-sizing="form-wrapper"] {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: visible !important;
      background: transparent !important;
      box-shadow: none !important;
    }

    section[role="dialog"][data-sizing="form-wrapper"] {
      display: block !important;
      border: 0 !important;
      color: #0d1710 !important;
    }

    .zv-review-form-title {
      display: none !important;
    }

    .zv-review-incentive {
      box-sizing: border-box !important;
      display: block !important;
      width: 100% !important;
      max-width: 920px !important;
      margin: 0 0 24px !important;
      padding: 10px 14px !important;
      border: 0 !important;
      border-left: 3px solid #a4f048 !important;
      border-radius: 0 12px 12px 0 !important;
      background: #f5faed !important;
      box-shadow: none !important;
    }

    section[role="dialog"][data-sizing="form-wrapper"] .zv-review-incentive p {
      margin: 0 !important;
      color: #172219 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 14.5px !important;
      font-weight: 500 !important;
      line-height: 1.45 !important;
    }

    section[role="dialog"][data-sizing="form-wrapper"] > .zv-review-image-slot,
    .zv-review-form-utility {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      white-space: nowrap !important;
      border: 0 !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }

    .zv-review-content-slot {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .zv-review-grid-contents {
      display: contents !important;
    }

    form.zv-review-form {
      box-sizing: border-box !important;
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 20px 18px !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      overflow: visible !important;
    }

    form.zv-review-form,
    form.zv-review-form * {
      box-sizing: border-box !important;
    }

    .zv-review-field {
      position: relative !important;
      min-width: 0 !important;
      max-width: 100% !important;
      margin: 0 !important;
      font-family: Poppins, Arial, sans-serif !important;
    }

    .zv-review-field--full,
    .zv-review-submit-row,
    .zv-review-form-alert {
      grid-column: 1 / -1 !important;
    }

    .zv-review-field label,
    .zv-review-field p,
    .zv-review-field legend {
      color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-weight: 600 !important;
    }

    .zv-review-control-field,
    .zv-review-textarea-field {
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 8px !important;
    }

    .zv-review-field.zv-review-textarea-field::before {
      display: none !important;
      content: none !important;
    }

    .zv-review-control-label {
      position: static !important;
      inset: auto !important;
      top: auto !important;
      right: auto !important;
      bottom: auto !important;
      left: auto !important;
      z-index: auto !important;
      display: inline-flex !important;
      align-items: center !important;
      align-self: flex-start !important;
      order: -1 !important;
      width: auto !important;
      height: auto !important;
      min-width: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: visible !important;
      clip: auto !important;
      clip-path: none !important;
      transform: none !important;
      white-space: normal !important;
      opacity: 1 !important;
      border: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 1.35 !important;
      letter-spacing: -.01em !important;
      pointer-events: auto !important;
    }

    .zv-review-required-dot {
      display: inline-block !important;
      flex: 0 0 8px !important;
      width: 8px !important;
      height: 8px !important;
      margin-inline-start: 7px !important;
      border: 1px solid #315f00 !important;
      border-radius: 50% !important;
      background: #4f8b0c !important;
      box-shadow: 0 0 0 2px #eef9dd !important;
      vertical-align: .12em !important;
    }

    .zv-review-control-field > input,
    .zv-review-control-field > textarea,
    .zv-review-control-field > select,
    .zv-review-textarea-field > textarea {
      order: 0 !important;
    }

    .zv-review-control-field > [role="alert"],
    .zv-review-control-field > [data-testid*="error"] {
      order: 1 !important;
    }

    .zv-review-field input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]):not([type="submit"]):not([type="button"]),
    .zv-review-field textarea,
    .zv-review-field select,
    .zv-review-field button[aria-expanded]:not([type="submit"]),
    .zv-review-field [role="combobox"] {
      box-sizing: border-box !important;
      max-width: 100% !important;
      min-height: 52px !important;
      border: 1px solid rgba(17, 24, 17, .18) !important;
      border-radius: 14px !important;
      outline: 0 !important;
      background-color: #f8faf5 !important;
      color: #0d1710 !important;
      box-shadow: none !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 15px !important;
      font-weight: 300 !important;
      line-height: 1.2 !important;
      letter-spacing: normal !important;
      transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease !important;
    }

    .zv-review-field input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]):not([type="submit"]):not([type="button"]),
    .zv-review-field select {
      width: 100% !important;
      height: 52px !important;
      padding: 0 18px !important;
    }

    .zv-review-field select {
      padding-right: 42px !important;
    }

    .zv-review-field button[role="combobox"]:not(.zv-review-phone-country),
    .zv-review-field button[aria-expanded]:not([type="submit"]):not(.zv-review-phone-country),
    .zv-review-field [role="combobox"]:not(.zv-review-phone-country) {
      width: 100% !important;
    }

    .zv-review-field textarea {
      display: block !important;
      width: 100% !important;
      min-height: 156px !important;
      padding: 17px 18px !important;
      resize: vertical !important;
      line-height: 1.5 !important;
    }

    .zv-review-field input::placeholder,
    .zv-review-field textarea::placeholder {
      color: #657067 !important;
      opacity: 1 !important;
    }

    .zv-review-textarea-field textarea::placeholder {
      color: #4f5b51 !important;
      font-size: 14.5px !important;
      font-weight: 500 !important;
    }

    .zv-review-field input:focus,
    .zv-review-field textarea:focus,
    .zv-review-field select:focus,
    .zv-review-field button[aria-expanded]:focus-visible,
    .zv-review-field [role="combobox"]:focus-visible {
      border-color: rgba(164, 240, 72, .95) !important;
      outline: 2px solid #0d1710 !important;
      outline-offset: 2px !important;
      background-color: #fff !important;
      box-shadow: 0 0 0 5px rgba(164, 240, 72, .18) !important;
    }

    .zv-review-field input[aria-invalid="true"],
    .zv-review-field textarea[aria-invalid="true"],
    .zv-review-field select[aria-invalid="true"] {
      border-color: #a12e25 !important;
      box-shadow: 0 0 0 3px rgba(161, 46, 37, .12) !important;
    }

    .zv-review-choice-group {
      min-inline-size: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
    }

    .zv-review-choice-group > legend {
      display: flex !important;
      align-items: center !important;
      width: 100% !important;
      margin: 0 0 11px !important;
      padding: 0 !important;
      color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 14.5px !important;
      font-weight: 700 !important;
      line-height: 1.35 !important;
      letter-spacing: -.01em !important;
    }

    .zv-review-choice-options {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 10px !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .zv-review-choice-option {
      position: relative !important;
      display: flex !important;
      align-items: center !important;
      gap: 12px !important;
      min-width: 0 !important;
      min-height: 54px !important;
      margin: 0 !important;
      padding: 13px 15px !important;
      border: 1px solid rgba(17, 24, 17, .14) !important;
      border-radius: 14px !important;
      background: #f8faf5 !important;
      color: #172219 !important;
      box-shadow: none !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 1.35 !important;
      cursor: pointer !important;
      transition: border-color .18s ease, background-color .18s ease, box-shadow .18s ease, transform .18s ease !important;
    }

    .zv-review-choice-option > span {
      min-width: 0 !important;
      color: inherit !important;
      font: inherit !important;
      overflow-wrap: anywhere !important;
    }

    .zv-review-choice-control {
      display: grid !important;
      place-items: center !important;
      flex: 0 0 22px !important;
      width: 22px !important;
      height: 22px !important;
      min-width: 22px !important;
      min-height: 22px !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .zv-review-choice-option input[type="radio"],
    .zv-review-choice-option input[type="checkbox"] {
      position: relative !important;
      display: block !important;
      appearance: none !important;
      -webkit-appearance: none !important;
      flex: 0 0 22px !important;
      width: 22px !important;
      height: 22px !important;
      min-width: 22px !important;
      min-height: 22px !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 1.5px solid #69746b !important;
      outline: 0 !important;
      background: #fff !important;
      box-shadow: none !important;
      cursor: pointer !important;
    }

    .zv-review-choice-option input[type="radio"] {
      border-radius: 50% !important;
    }

    .zv-review-choice-option input[type="checkbox"] {
      border-radius: 6px !important;
    }

    .zv-review-choice-option input[type="radio"]:checked {
      border-color: #0d1710 !important;
      background: radial-gradient(circle at center, #0d1710 0 4px, #a4f048 4.5px 100%) !important;
    }

    .zv-review-choice-option input[type="checkbox"]:checked {
      border-color: #0d1710 !important;
      background: #a4f048 !important;
    }

    .zv-review-choice-option input[type="checkbox"]:checked::after {
      position: absolute !important;
      top: 2px !important;
      left: 6px !important;
      width: 6px !important;
      height: 11px !important;
      border: solid #0d1710 !important;
      border-width: 0 2px 2px 0 !important;
      content: '' !important;
      transform: rotate(45deg) !important;
    }

    .zv-review-choice-option.zv-review-choice-option--selected,
    .zv-review-choice-option:has(input:checked) {
      border-color: #4f8b0c !important;
      background: linear-gradient(180deg, #f2fbdf 0%, #eaf8d2 100%) !important;
      box-shadow: inset 0 0 0 1px rgba(79, 139, 12, .2), 0 5px 14px rgba(57, 103, 14, .08) !important;
      color: #0d1710 !important;
      font-weight: 700 !important;
    }

    .zv-review-choice-option:focus-within,
    .zv-review-choice-option:has(input:focus-visible) {
      outline: 2px solid #0d1710 !important;
      outline-offset: 2px !important;
      box-shadow: 0 0 0 5px rgba(164, 240, 72, .28) !important;
    }

    .zv-review-choice-option.zv-review-choice-option--disabled,
    .zv-review-choice-option:has(input:disabled),
    .zv-review-choice-option:has(input[aria-disabled="true"]) {
      cursor: not-allowed !important;
      opacity: .58 !important;
      transform: none !important;
    }

    .zv-review-choice-option input:disabled,
    .zv-review-choice-option input[aria-disabled="true"] {
      cursor: not-allowed !important;
    }

    @media (hover: hover) {
      .zv-review-choice-option:not(.zv-review-choice-option--disabled):not(:has(input:disabled)):not(:has(input[aria-disabled="true"])):hover {
        border-color: #6d9f34 !important;
        background: #f3f9ea !important;
        transform: translateY(-1px) !important;
      }

      .zv-review-choice-option.zv-review-choice-option--selected:not(.zv-review-choice-option--disabled):not(:has(input:disabled)):not(:has(input[aria-disabled="true"])):hover,
      .zv-review-choice-option:has(input:checked):not(:has(input:disabled)):not(:has(input[aria-disabled="true"])):hover {
        background: linear-gradient(180deg, #effbda 0%, #e5f6ca 100%) !important;
      }
    }

    .zv-review-field [role="alert"],
    .zv-review-field [data-testid*="error"],
    .zv-review-form-alert,
    form.zv-review-form > [role="alert"],
    form.zv-review-form > [data-testid*="error"] {
      color: #8a3028 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 12.5px !important;
      line-height: 1.4 !important;
    }

    button.zv-review-submit {
      box-sizing: border-box !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      min-height: 48px !important;
      margin: 0 !important;
      padding: 12px 22px !important;
      border: 1px solid #a4f048 !important;
      border-radius: 999px !important;
      outline: 0 !important;
      background: #a4f048 !important;
      color: #0d1710 !important;
      box-shadow: none !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 1.2 !important;
      text-align: center !important;
      cursor: pointer !important;
      transition: background-color .18s ease, border-color .18s ease, box-shadow .18s ease !important;
    }

    button.zv-review-submit:hover {
      border-color: #b3ff55 !important;
      background: #b3ff55 !important;
    }

    button.zv-review-submit:focus-visible {
      outline: 2px solid #0d1710 !important;
      outline-offset: 2px !important;
      box-shadow: 0 0 0 5px rgba(164, 240, 72, .22) !important;
    }

    button.zv-review-submit[aria-disabled="true"],
    button.zv-review-submit:disabled {
      cursor: wait !important;
      opacity: .68 !important;
    }

    section[role="dialog"][data-sizing="form-wrapper"] h1,
    section[role="dialog"][data-sizing="form-wrapper"] h2,
    section[role="dialog"][data-sizing="form-wrapper"] h3 {
      color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-weight: 700 !important;
      letter-spacing: -.025em !important;
    }

    section[role="dialog"][data-sizing="form-wrapper"] p {
      color: #263426 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-weight: 300 !important;
      line-height: 1.5 !important;
    }

    .zv-review-action-note {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 13px auto 0 !important;
      padding: 0 12px !important;
      text-align: center !important;
    }

    section[role="dialog"][data-sizing="form-wrapper"] .zv-review-action-note p {
      width: 100% !important;
      max-width: 1120px !important;
      margin: 0 auto !important;
      color: #4f5b51 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 11.5px !important;
      font-weight: 400 !important;
      line-height: 1.5 !important;
      text-align: center !important;
    }

    @media (max-width: 989px) {
      form.zv-review-form {
        grid-template-columns: minmax(0, 1fr) !important;
      }

      .zv-review-field,
      .zv-review-field--full,
      .zv-review-submit-row {
        grid-column: 1 !important;
      }

      .zv-review-choice-options {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      }
    }

    @media (max-width: 749px) {
      .zv-review-field input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]):not([type="submit"]):not([type="button"]),
      .zv-review-field textarea,
      .zv-review-field select,
      .zv-review-field button[aria-expanded]:not([type="submit"]),
      .zv-review-field [role="combobox"] {
        font-size: 16px !important;
      }

      button.zv-review-submit {
        white-space: normal !important;
      }

      .zv-review-choice-options {
        grid-template-columns: minmax(0, 1fr) !important;
      }

      .zv-review-incentive {
        margin-bottom: 20px !important;
        padding: 9px 12px !important;
      }

      .zv-review-incentive p {
        font-size: 13.5px !important;
      }

      .zv-review-action-note {
        margin-top: 11px !important;
        padding: 0 4px !important;
      }

      .zv-review-control-label {
        font-size: 14px !important;
      }

      section[role="dialog"][data-sizing="form-wrapper"] .zv-review-action-note p {
        font-size: 11px !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .zv-review-field input,
      .zv-review-field textarea,
      .zv-review-field select,
      .zv-review-field button,
      .zv-review-choice-option,
      button.zv-review-submit {
        transition: none !important;
      }

      .zv-review-choice-option {
        transform: none !important;
      }
    }

    @media (forced-colors: active) {
      .zv-review-choice-option {
        border: 1px solid CanvasText !important;
        background: Canvas !important;
        color: CanvasText !important;
        forced-color-adjust: auto !important;
      }

      .zv-review-choice-option input[type="radio"],
      .zv-review-choice-option input[type="checkbox"] {
        appearance: auto !important;
        -webkit-appearance: auto !important;
      }

      .zv-review-choice-option.zv-review-choice-option--selected,
      .zv-review-choice-option:has(input:checked) {
        outline: 2px solid Highlight !important;
        outline-offset: 1px !important;
      }

      .zv-review-required-dot {
        border-color: CanvasText !important;
        background: CanvasText !important;
        box-shadow: none !important;
        forced-color-adjust: auto !important;
      }
    }
    /* Homepage action styles also apply inside Shopify Forms' shadow root.
       Only presentation is shared; submission, validation and consent stay native. */
    button.zv-review-submit {
      height: var(--zv-button-height, 48px) !important;
      min-height: var(--zv-button-height, 48px) !important;
      max-height: var(--zv-button-height, 48px) !important;
      padding: 6px 22px !important;
      gap: 10px !important;
      border-radius: 999px !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      line-height: 1.15 !important;
      letter-spacing: -.01em !important;
      white-space: normal !important;
    }
    button.zv-review-submit::after {
      content: '';
      display: none;
    }
    button.zv-review-submit::after {
      content: '';
      display: block;
      position: static;
      width: 17px;
      height: 17px;
      flex: 0 0 17px;
      border: 0;
      background: currentColor;
      -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='m8 4 8 8-8 8' fill='none' stroke='black' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / contain no-repeat;
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='m8 4 8 8-8 8' fill='none' stroke='black' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / contain no-repeat;
      transform: none;
    }
    button.zv-review-submit:hover {
      background: #b7ff5c !important;
      border-color: transparent !important;
    }

  `;

  const fieldWrapperFor = (control, form, primaryControls) => {
    let node = control;
    let candidate = control;

    while (node.parentElement && node.parentElement !== form) {
      const parent = node.parentElement;
      const containedControls = primaryControls.filter((item) => parent.contains(item));
      if (containedControls.length !== 1) break;
      candidate = parent;
      node = parent;
    }

    return form.contains(candidate) ? candidate : null;
  };

  const markGridPath = (wrapper, form) => {
    let parent = wrapper?.parentElement;
    while (parent && parent !== form) {
      parent.classList.add('zv-review-grid-contents');
      parent = parent.parentElement;
    }
  };

  const submitWrapperFor = (button, form, primaryControls) => {
    let node = button;
    let candidate = button;

    while (node.parentElement && node.parentElement !== form) {
      const parent = node.parentElement;
      if (primaryControls.some((control) => parent.contains(control))) break;
      if (parent.querySelectorAll('button[type="submit"], [data-testid="btn-form-submit"]').length !== 1) break;
      candidate = parent;
      node = parent;
    }

    return candidate;
  };

  const isPhoneAuxiliaryControl = (control, form) => {
    if (!control.matches('button[aria-expanded], button[role="combobox"]')) return false;
    const explicitPhoneComponent = control.closest([
      's-phone-field',
      'shopify-phone-field',
      '[data-phone-field]',
      '[data-field-type="phone"]',
      '[data-testid*="phone-field"]'
    ].join(','));
    if (explicitPhoneComponent && form.contains(explicitPhoneComponent)) return true;

    let parent = control.parentElement;
    while (parent && parent !== form) {
      if (parent.querySelector('input[type="tel"]')) {
        const competingControls = Array.from(parent.querySelectorAll([
          'input:not([type="hidden"]):not([type="tel"]):not([type="submit"]):not([type="button"])',
          'textarea',
          'select',
          'fieldset',
          '[role="radiogroup"]',
          '[role="group"]',
          'button[aria-expanded]:not([type="submit"])',
          'button[role="combobox"]'
        ].join(','))).filter((candidate) => candidate !== control);
        return competingControls.length === 0;
      }
      parent = parent.parentElement;
    }
    return false;
  };

  const uniqueElements = (elements) => Array.from(new Set(elements.filter(Boolean)));

  const labelsForControl = (control, form) => {
    const labels = Array.from(control.labels || []);
    const wrappingLabel = control.closest('label');
    if (wrappingLabel) labels.push(wrappingLabel);

    const controlId = control.getAttribute('id');
    if (controlId) {
      form.querySelectorAll('label').forEach((label) => {
        if (label.getAttribute('for') === controlId) labels.push(label);
      });
    }

    return uniqueElements(labels).filter((label) => form.contains(label));
  };

  const lowestCommonAncestor = (elements, boundary) => {
    if (!elements.length) return null;
    let candidate = elements[0];
    while (candidate && candidate !== boundary) {
      if (elements.every((element) => candidate.contains(element))) return candidate;
      candidate = candidate.parentElement;
    }
    return elements.every((element) => boundary.contains(element)) ? boundary : null;
  };

  const setRequiredMarker = (prompt, isRequired) => {
    if (!prompt) return;
    const existingMarker = Array.from(prompt.children).find((child) => {
      return child.classList.contains('zv-review-required-dot');
    });

    if (!isRequired) {
      existingMarker?.remove();
      return;
    }

    if (existingMarker) return;
    const marker = document.createElement('span');
    marker.className = 'zv-review-required-dot';
    marker.setAttribute('aria-hidden', 'true');
    prompt.appendChild(marker);
  };

  const setControlRequired = (control, isRequired) => {
    if ('required' in control && control.required !== isRequired) {
      control.required = isRequired;
    }
    if (isRequired) {
      if (control.getAttribute('aria-required') !== 'true') {
        control.setAttribute('aria-required', 'true');
      }
    } else {
      control.removeAttribute('aria-required');
    }
  };

  const syncChoiceGroupRequired = (wrapper) => {
    const inputs = Array.from(
      wrapper.querySelectorAll('input[type="radio"], input[type="checkbox"]')
    );
    if (!inputs.length) return inputs;

    if (wrapper.getAttribute('aria-required') !== 'true') {
      wrapper.setAttribute('aria-required', 'true');
    }
    const legend = wrapper.querySelector(':scope > legend') || wrapper.querySelector('legend');
    setRequiredMarker(legend, true);

    const isRadioGroup = inputs.some((input) => input.type === 'radio');
    const hasCheckedCheckbox = inputs.some((input) => {
      return input.type === 'checkbox' && input.checked;
    });
    inputs.forEach((input, index) => {
      const shouldRequire = isRadioGroup || (!hasCheckedCheckbox && index === 0);
      if (input.required !== shouldRequire) input.required = shouldRequire;
    });

    return inputs;
  };

  const decorateChoiceGroup = (wrapper, form) => {
    const inputs = syncChoiceGroupRequired(wrapper);
    if (!inputs.length) return;
    const isRadioGroup = inputs.some((input) => input.type === 'radio');

    const labels = uniqueElements(inputs.flatMap((input) => labelsForControl(input, form)));
    if (!labels.length) return;

    wrapper.classList.add('zv-review-choice-group');
    wrapper.classList.toggle(
      'zv-review-choice-group--radio',
      isRadioGroup
    );
    wrapper.classList.toggle(
      'zv-review-choice-group--checkbox',
      inputs.some((input) => input.type === 'checkbox')
    );

    const optionsContainer = lowestCommonAncestor(labels, wrapper);
    if (optionsContainer && optionsContainer !== wrapper && !optionsContainer.matches('label')) {
      optionsContainer.classList.add('zv-review-choice-options');
    }

    labels.forEach((label) => {
      const labelInputs = inputs.filter((input) => {
        return label.contains(input) || Array.from(input.labels || []).includes(label);
      });
      const input = labelInputs[0] || inputs.find((candidate) => {
        return label.getAttribute('for') && label.getAttribute('for') === candidate.getAttribute('id');
      });
      if (!input) return;

      label.classList.add('zv-review-choice-option');
      label.classList.toggle('zv-review-choice-option--selected', input.checked);
      label.classList.toggle(
        'zv-review-choice-option--disabled',
        input.disabled || input.getAttribute('aria-disabled') === 'true'
      );

      if (input.parentElement !== label && label.contains(input)) {
        input.parentElement?.classList.add('zv-review-choice-control');
      }
    });
  };

  const copyFromOuter = (outer, dataKey, fallback) => {
    const value = String(outer?.dataset?.[dataKey] || '').trim();
    return value || fallback;
  };

  const decorateRatingLegend = (form, outer) => {
    const ratingLabel = copyFromOuter(outer, 'zvReviewRatingLabel', DEFAULT_RATING_LABEL);
    const ratingFieldset = Array.from(form.querySelectorAll('fieldset')).find((fieldset) => {
      return fieldset.querySelector('input[type="radio"]')
        && fieldset.querySelector('legend')
        && /(?:hoe\s+tevreden|how\s+satisfied)/i.test(fieldset.querySelector('legend').textContent);
    });
    const legend = ratingFieldset?.querySelector('legend');
    if (legend && legend.textContent.trim() !== ratingLabel) legend.textContent = ratingLabel;
  };

  const decorateActionNote = (form) => {
    const note = form.nextElementSibling;
    const noteParagraph = note?.querySelector(':scope > p');
    if (
      note?.matches('div')
      && [DISCLAIMER_PREFIX, 'by submitting this form'].some((prefix) => noteParagraph?.textContent.trim().toLowerCase().startsWith(prefix))
    ) {
      note.classList.add('zv-review-action-note');
    }
  };

  const decorateTextarea = (wrapper, outer) => {
    const textarea = wrapper.querySelector('textarea');
    if (!textarea) return;

    const placeholder = copyFromOuter(
      outer,
      'zvReviewTextareaPlaceholder',
      DEFAULT_TEXTAREA_PLACEHOLDER
    );
    if (textarea.getAttribute('placeholder') !== placeholder) {
      textarea.setAttribute('placeholder', placeholder);
    }

    const sourceLabel = Array.from(wrapper.querySelectorAll('label')).find((label) => {
      return label.contains(textarea)
        || (textarea.id && label.getAttribute('for') === textarea.id)
        || (!textarea.id && label.getAttribute('for') === textarea.getAttribute('name'));
    }) || wrapper.querySelector('label');

    const labelFor = sourceLabel?.getAttribute('for');
    if (!textarea.id && labelFor) textarea.id = labelFor;

    wrapper.classList.add('zv-review-textarea-field');
    wrapper.querySelectorAll(':scope > .zv-review-display-label').forEach((displayLabel) => {
      displayLabel.remove();
    });

    return textarea;
  };

  const decorateControlField = (wrapper, form, outer) => {
    const textarea = decorateTextarea(wrapper, outer);
    const control = textarea || wrapper.querySelector([
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"])',
      'textarea',
      'select'
    ].join(','));
    if (!control || control.disabled) return;

    wrapper.classList.add('zv-review-control-field');
    const labels = labelsForControl(control, form);
    const label = labels.find((candidate) => !candidate.contains(control))
      || labels[0]
      || wrapper.querySelector('label');
    if (label) {
      label.classList.add('zv-review-control-label');
      setRequiredMarker(label, true);
    }
    setControlRequired(control, true);
  };

  const installStyle = (shadow) => {
    const existingStyle = shadow.getElementById(STYLE_ID);
    if (existingStyle) {
      if (existingStyle.textContent !== SHADOW_CSS) existingStyle.textContent = SHADOW_CSS;
      return;
    }
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = SHADOW_CSS;
    shadow.appendChild(style);
  };

  const markLayout = (shadow, outer) => {
    installStyle(shadow);
    shadow.querySelectorAll('.zv-review-incentive-badge').forEach((badge) => badge.remove());

    const dialog = shadow.querySelector('section[role="dialog"][data-sizing="form-wrapper"]');
    const form = shadow.querySelector('form[data-testid="form"], form');
    const success = shadow.querySelector('[data-testid="banner-success"]');
    const successStyle = success ? window.getComputedStyle(success) : null;
    const successVisible = Boolean(
      success
      && !success.hidden
      && success.getAttribute('aria-hidden') !== 'true'
      && successStyle
      && successStyle.display !== 'none'
      && successStyle.visibility !== 'hidden'
      && success.getClientRects().length > 0
    );

    if (successVisible) {
      shadow.querySelectorAll('.zv-review-incentive').forEach((element) => {
        element.classList.remove('zv-review-incentive');
      });
      shadow.querySelectorAll('.zv-review-form-title').forEach((title) => {
        title.classList.remove('zv-review-form-title');
      });
      outer?.classList.remove('is-zv-review-ready');
      outer?.classList.add('is-zv-review-success');
      return;
    }

    if (!form) {
      outer?.classList.remove('is-zv-review-ready', 'is-zv-review-success');
      return;
    }

    if (form.noValidate) form.noValidate = false;

    outer?.classList.remove('is-zv-review-success');
    form.classList.remove('zv-review-form');

    shadow.querySelectorAll('.zv-review-form-title').forEach((titleNode) => {
      titleNode.classList.remove('zv-review-form-title');
    });
    const header = form.previousElementSibling;
    const internalTitle = header?.querySelector('h1, h2, h3');
    internalTitle?.classList.add('zv-review-form-title');

    shadow.querySelectorAll([
      '.zv-review-field',
      '.zv-review-field--full',
      '.zv-review-form-utility',
      '.zv-review-submit-row',
      '.zv-review-submit',
      '.zv-review-phone-country',
      '.zv-review-grid-contents',
      '.zv-review-form-alert',
      '.zv-review-content-slot',
      '.zv-review-image-slot',
      '.zv-review-incentive',
      '.zv-review-action-note',
      '.zv-review-control-field',
      '.zv-review-control-label',
      '.zv-review-textarea-field',
      '.zv-review-source-label',
      '.zv-review-choice-group',
      '.zv-review-choice-group--radio',
      '.zv-review-choice-group--checkbox',
      '.zv-review-choice-options',
      '.zv-review-choice-option',
      '.zv-review-choice-control',
      '.zv-review-choice-option--selected',
      '.zv-review-choice-option--disabled'
    ].join(',')).forEach((element) => {
      element.classList.remove(
        'zv-review-field',
        'zv-review-field--full',
        'zv-review-form-utility',
        'zv-review-submit-row',
        'zv-review-submit',
        'zv-review-phone-country',
        'zv-review-grid-contents',
        'zv-review-form-alert',
        'zv-review-content-slot',
        'zv-review-image-slot',
        'zv-review-incentive',
        'zv-review-action-note',
        'zv-review-control-field',
        'zv-review-control-label',
        'zv-review-textarea-field',
        'zv-review-source-label',
        'zv-review-choice-group',
        'zv-review-choice-group--radio',
        'zv-review-choice-group--checkbox',
        'zv-review-choice-options',
        'zv-review-choice-option',
        'zv-review-choice-control',
        'zv-review-choice-option--selected',
        'zv-review-choice-option--disabled'
      );
    });

    const incentive = Array.from(header?.children || []).find((element) => {
      const text = element.textContent.trim().toLocaleLowerCase('nl-NL');
      return element !== internalTitle && (text.includes('€100') || text.includes('eerlijke ervaring') || text.includes('honest experience'));
    });
    incentive?.classList.add('zv-review-incentive');
    decorateRatingLegend(form, outer);
    decorateActionNote(form);

    const groupControls = Array.from(form.querySelectorAll([
      'fieldset',
      '[role="radiogroup"]',
      '[role="group"]'
    ].join(','))).filter((group) => {
      const parentGroup = group.parentElement?.closest('fieldset, [role="radiogroup"], [role="group"]');
      return !parentGroup || !form.contains(parentGroup);
    });

    const leafControls = Array.from(form.querySelectorAll([
      'input:not([type="hidden"]):not([type="submit"]):not([type="button"])',
      'textarea',
      'select',
      'button[role="combobox"]',
      'button[aria-expanded]:not([type="submit"])'
    ].join(','))).filter((control) => {
      return !groupControls.some((group) => group.contains(control))
        && !isPhoneAuxiliaryControl(control, form);
    });

    const primaryControls = [...groupControls, ...leafControls];
    const wrappers = new Set();
    primaryControls.forEach((control) => {
      const wrapper = fieldWrapperFor(control, form, primaryControls);
      if (wrapper) wrappers.add(wrapper);
    });

    const submitButtons = Array.from(
      form.querySelectorAll('button[type="submit"], [data-testid="btn-form-submit"]')
    );
    const ready = primaryControls.length > 0 && wrappers.size > 0 && submitButtons.length > 0;
    if (!ready) {
      outer?.classList.remove('is-zv-review-ready');
      return;
    }

    form.classList.add('zv-review-form');

    if (dialog) {
      const directChildren = Array.from(dialog.children);
      const contentSlot = directChildren.find((child) => child.contains(form));
      const imageSlot = directChildren.find((child) => {
        if (child === contentSlot) return false;
        const hasMedia = Boolean(child.querySelector('img, picture'));
        const hasInteractiveOrStatus = Boolean(child.querySelector(
          'form, input, textarea, select, button, a, iframe, [role="alert"], [aria-live]'
        ));
        return !hasInteractiveOrStatus && (hasMedia || !child.textContent.trim());
      });
      directChildren.forEach((child) => {
        child.classList.toggle('zv-review-content-slot', child === contentSlot);
        child.classList.toggle('zv-review-image-slot', child === imageSlot);
      });
    }

    form.querySelectorAll('shop-lead-capture').forEach((capture) => {
      let utility = capture;
      while (utility.parentElement && utility.parentElement !== form) {
        const parent = utility.parentElement;
        if (primaryControls.some((control) => parent.contains(control))) break;
        utility = parent;
      }
      if (!primaryControls.some((control) => utility.contains(control))) {
        utility.classList.add('zv-review-form-utility');
      }
    });

    wrappers.forEach((wrapper) => {
      wrapper.classList.add('zv-review-field');
      markGridPath(wrapper, form);
      decorateChoiceGroup(wrapper, form);
      decorateControlField(wrapper, form, outer);
      if (wrapper.querySelector('input[type="tel"]')) {
        wrapper.querySelectorAll('button[aria-expanded], button[role="combobox"]').forEach((button) => {
          button.classList.add('zv-review-phone-country');
        });
      }
      const requiresFullWidth = wrappers.size === 1 || Boolean(wrapper.matches([
        'textarea',
        'fieldset',
        '[role="radiogroup"]',
        '[role="group"]'
      ].join(',')) || wrapper.querySelector([
        'textarea',
        'fieldset',
        'input[type="checkbox"]',
        'input[type="radio"]',
        'input[type="range"]',
        'input[type="file"]',
        '[role="radiogroup"]',
        '[role="group"]'
      ].join(',')));
      wrapper.classList.toggle('zv-review-field--full', requiresFullWidth);
    });

    form.querySelectorAll('[role="alert"], [data-testid*="error"]').forEach((alert) => {
      if (Array.from(wrappers).some((wrapper) => wrapper.contains(alert))) return;
      alert.classList.add('zv-review-form-alert');
      markGridPath(alert, form);
    });

    submitButtons.forEach((button) => {
      const wrapper = submitWrapperFor(button, form, primaryControls);
      wrapper.classList.add('zv-review-submit-row');
      markGridPath(wrapper, form);
      button.classList.add('zv-review-submit');
    });

    outer?.classList.add('is-zv-review-ready');
  };

  const attach = (host, outer) => {
    const shadow = host?.shadowRoot;
    if (!shadow) return false;

    markLayout(shadow, outer);
    if (!shadowObservers.has(shadow)) {
      let frame = 0;
      const refresh = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = 0;
          markLayout(shadow, outer);
        });
      };
      const observer = new MutationObserver(refresh);
      observer.observe(shadow, {
        attributes: true,
        attributeFilter: [
          'aria-hidden',
          'aria-required',
          'hidden',
          'novalidate',
          'required',
          'style'
        ],
        childList: true,
        characterData: true,
        subtree: true
      });
      shadow.addEventListener('click', refresh);
      shadow.addEventListener('change', (event) => {
        const changedControl = event.target;
        if (changedControl instanceof Element && changedControl.matches(
          'input[type="radio"], input[type="checkbox"]'
        )) {
          const group = changedControl.closest(
            'fieldset, [role="radiogroup"], [role="group"]'
          );
          if (group) syncChoiceGroupRequired(group);
        }
        refresh();
      });
      shadowObservers.set(shadow, observer);
    }
    return true;
  };

  const scan = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      const outer = root.closest('.zv-review-native-form');
      const host = root.matches(EMBED_SELECTOR) ? root : root.querySelector(EMBED_SELECTOR);
      attach(host, outer);
    });
  };

  let scanFrame = 0;
  const scheduleScan = () => {
    if (scanFrame) return;
    scanFrame = window.requestAnimationFrame(() => {
      scanFrame = 0;
      scan();
    });
  };

  const documentObserver = new MutationObserver(scheduleScan);

  const start = () => {
    scan();
    documentObserver.observe(document.documentElement, { childList: true, subtree: true });

    const deadline = Date.now() + 30000;
    const poll = window.setInterval(() => {
      scan();
      const root = document.querySelector(ROOT_SELECTOR);
      const hydrated = Boolean(root?.querySelector(EMBED_SELECTOR)?.shadowRoot);
      if (Date.now() >= deadline || hydrated) {
        window.clearInterval(poll);
      }
    }, 400);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleScan);
})();
